export function prependToNonHttpsHrefs(htmlString: string, prependText: string) {
  if (!htmlString) {
    return;
  }
  // Regular expression to match href attributes that don't include https
  const regex = /href="(?!https:\/\/|mailto:|tel:)([^"]*)"/g;

  // Replace href attributes with prepended text
  const modifiedHtml = htmlString.replace(regex, 'href="' + prependText + '$1"');

  return modifiedHtml;
}
